import styled from 'styled-components';

export const VideoInfoView = styled.div`
    background: ${({ theme }) => theme.root.colors.basicColors.black['16%']};
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 1;
`;
